"use client";

import HeroSection from "@/components/page-section/HeroSection/HeroSection";
import type { CoSoVatChatHeroContent } from "@/components/page/CoSoVatChat/types";
import {
  overlayDefaultsFromCmsFields,
  slideItemsFromCmsRows,
} from "@/utils/cms-hero-slides";
import { normalizeCmsAssetUrl } from "@/utils/media-url";

type Props = {
  hero?: CoSoVatChatHeroContent | null;
};

const FALLBACK = {
  brand: "HUB",
  title: "CƠ SỞ VẬT CHẤT",
  label: "Xem chi tiết",
  href: "#about",
};

export default function CoSoVatChatHero({ hero }: Props) {
  const heroSlides = (() => {
    const fromSlides = slideItemsFromCmsRows(hero?.slides ?? null);
    if (fromSlides) return fromSlides;
    if (hero?.image) {
      const img = normalizeCmsAssetUrl(hero.image) || hero.image;
      return [
        {
          image: img,
          mobileImage: hero.mobileImage ?? hero.image,
          alt: hero.alt ?? "Banner",
        },
      ];
    }
    return null;
  })();

  const hasNewCmsShape = !!hero?.slides?.length;

  const overlayDefaults = hasNewCmsShape
    ? overlayDefaultsFromCmsFields(hero?.brand, hero?.title, hero?.button, FALLBACK)
    : null;

  return (
    <HeroSection
      pageKey="co-so-vat-chat"
      variant="carousel"
      sectionModifier="hero-section--banner hero-section--cosovatchat"
      ariaLabel="Banner cơ sở vật chất"
      overrideSlides={heroSlides}
      overlayDefaults={overlayDefaults}
      breadcrumb={[
        { label: "Trang chủ", href: "/" },
        { label: "Cơ sở vật chất" },
      ]}
    />
  );
}
